import { Component, inject } from '@angular/core';
import { SvgIconComponent } from '@utilities/components/svg-icon/svg-icon.component';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';
import { OktaAuthStateService } from '@okta/okta-angular';
import { AuthState } from '@okta/okta-auth-js';
import { filter, map } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [SvgIconComponent, RouterLink, AsyncPipe],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  private oktaStateService = inject(OktaAuthStateService);
  public authService = inject(AuthService);
  public isAuthenticated$ = this.oktaStateService.authState$.pipe(
    filter((s: AuthState) => !!s),
    map((s: AuthState) => s.isAuthenticated ?? false),
  );

  openWhastApp(): void{
    window.open('https://api.whatsapp.com/send?phone=5215585607670', '_blank');
  }
}
